import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '@lmc/ui-kit'
import { colors } from '@lmc/common/constants'

interface CarePlanSectionHeaderProps {
  title: string
}

const CarePlanSectionHeader: React.FC<CarePlanSectionHeaderProps> = ({
  title,
}) => (
  <div>
    <Text as="h4" style={styles.title}>
      {title}
    </Text>
  </div>
)

const styles = {
  title: { color: colors.black, opacity: 0.7 },
}

CarePlanSectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
}

export default CarePlanSectionHeader
